import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: 'process',
    loadChildren: async () =>
      (await import('./modules/request.module')).RequestModule
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'process',
  },
  {
    path: '**',
    redirectTo: 'process'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
